import React, { ReactElement, ReactNode } from 'react'
// Externals imports.
import MUIDrawer from '@material-ui/core/Drawer'
// Sub imports.
import { DrawerPosition } from './Constants'

/**
 * Component properties type.
 */
type Props = {
    children: ReactNode
    position: DrawerPosition
    isOpen: boolean
    container: HTMLElement | null
    className?: string
}

/**
 * The drawer UI component that supports different anchor positions.
 *
 * @param children Children to render.
 * @param position The position of the drawer.
 * @param isOpen Whether the drawer is open.
 * @param container The reference to the container of the drawer.
 * @param className The class name of the drawer.
 */
const Drawer: React.FC<Props> = ({ className, children, position, isOpen, container }: Props): ReactElement => (
    <MUIDrawer variant='persistent' anchor={position} open={isOpen} ModalProps={{ container }} className={className}>
        {children}
    </MUIDrawer>
)

export default Drawer
